import { useState } from "preact/hooks";
import { AerialPlacement } from "../lib/maps/AerialPlacement";
import type { Placement } from "../lib/maps/types";
import { footprintForSku } from "../lib/skuDimensions";

// Kasselman Solar HQ, Menands NY — a stable demo target with clear roof/yard.
const DEMO_ADDRESS = "312 Broadway, Menands, NY 12204";
const DEMO_SKU = "generac-guardian-26kw";

export function PlacementDemo() {
  const [placement, setPlacement] = useState<Placement | null>(null);
  const [saved, setSaved] = useState<Placement | null>(null);
  const [mode, setMode] = useState<"live" | "rerender">("live");
  const overlay = footprintForSku(DEMO_SKU);

  return (
    <main class="wizard" style="max-width:820px;margin:0 auto;padding:1rem;">
      <h2>Aerial placement — POC (#44)</h2>
      <p class="blurb">
        Live Google hybrid map. Drag and rotate the to-scale footprint; it holds scale
        across zoom. We store only coordinates — never map imagery.
      </p>

      {mode === "live" ? (
        <AerialPlacement
          key="live"
          address={DEMO_ADDRESS}
          overlay={overlay}
          onChange={setPlacement}
        />
      ) : (
        <AerialPlacement
          key={JSON.stringify(saved)}
          address={DEMO_ADDRESS}
          overlay={overlay}
          initial={saved}
          onChange={setPlacement}
        />
      )}

      <div style="display:flex;gap:0.5rem;margin-top:0.75rem;">
        <button
          class="primary"
          onClick={() => { setSaved(placement); setMode("rerender"); }}
          disabled={!placement}
        >
          Save + re-render from stored coordinates
        </button>
        <button onClick={() => setMode("live")}>Back to live</button>
      </div>

      <h3 style="margin-top:1rem;">Stored Placement</h3>
      <pre style="background:#f5f5f5;padding:0.75rem;border-radius:6px;overflow:auto;">
        {JSON.stringify(placement, null, 2)}
      </pre>
    </main>
  );
}
